import type { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import type { TRenderedSocialItem, TSocialIcon } from 'shared/types/socials';

import * as styles from './styles.css';

interface ISocialsProps {
  title: string;
  items: TRenderedSocialItem[];
  device: TDeviceType;
  onItemClick?: (icon: TSocialIcon) => void;
}

export const Socials: React.FC<ISocialsProps> = ({ title, items, device, onItemClick }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['socials']}>
        {items.map(({ Icon, url, icon }) => (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles['social']}
            key={url}
            onClick={() => onItemClick?.(icon)}
          >
            <Icon />
          </a>
        ))}
      </div>
    </div>
  );
};
